import { captureException } from '@sentry/node';
import { IGetChannels, TChannelsResponse } from '~/src/services/api/api-epg/v1/dto/IChannelsDto';
import apiEpgRequest from '~/src/services/api/api-epg/v1';

/*
* Список каналов в разрезе провайдеров
* https://master.api-epg.sandbox.d2c.r-one.io/docs/#/v1/ChannelController_getChannelsByProviderId
*/

export const getChannels = async (providerId: number, params?: IGetChannels): Promise<TChannelsResponse> => {
    try {
        const response = await apiEpgRequest().get(`/api/v1/${providerId}/channels`, {
            params: params,
        });

        return {
            isSuccess: true,
            payload: response.data,
        };
    } catch (error) {
        captureException(error);

        return {
            isSuccess: false,
            error: error.response.data,
        };
    }
};
